import { onMounted, onUnmounted, reactive, toRefs } from "vue";

export function useMonitorSize() {
  const isMobile = () => window.innerWidth <= 600;
  const isMobileLarge = () => window.innerWidth < 768;
  const isSmallTablet = () => window.innerWidth < 1024;

  const sizes = reactive({
    browserWidth: window.innerWidth,
    deviceWidth: screen.width,
    isMobile: isMobile(),
    isMobileLarge: isMobileLarge(),
    isSmallTablet: isSmallTablet(),
  });

  const browserResized = () => {
    sizes.browserWidth = window.innerWidth;
    sizes.deviceWidth = screen.width;
    sizes.isMobile = isMobile();
    sizes.isMobileLarge = isMobileLarge();
    sizes.isSmallTablet = isSmallTablet();
  };

  onMounted(() => {
    window.addEventListener("resize", browserResized);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", browserResized);
  });

  return {
    ...toRefs(sizes),
  };
}
